import { ACTION_TYPES } from 'app/modules/logistic/service/store/action';
import { initialState } from 'app/modules/logistic/service/store/state';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/util/action-type.util';
import { BonTransportConstraint } from '../../model/bonTransportConstraint.response';
import { LogisticState } from './state';

export default (state: LogisticState = initialState, action): LogisticState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GENERATE_BP):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.GENERATE_BP): {
      return {
        ...state,
        logisticResponse: action.payload.data,
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GENERATE_BP): {
      return {
        ...initialState,
        loading: false,
      };
    }

    case REQUEST(ACTION_TYPES.GET_BENEFIT):
      return {
        ...state,
      };

    case SUCCESS(ACTION_TYPES.GET_BENEFIT): {
      return {
        ...state,
        benefitClaimResponse: action.payload.data,
      };
    }

    case FAILURE(ACTION_TYPES.GET_BENEFIT): {
      return {
        ...initialState,
      };
    }

    case REQUEST(ACTION_TYPES.GET_GEOLOCALISATION):
      return {
        ...state,
        loadingGeolocation: true,
      };

    case SUCCESS(ACTION_TYPES.GET_GEOLOCALISATION): {
      return {
        ...state,
        geolocalisation: action.payload.data,
        loadingGeolocation: false,
      };
    }

    case ACTION_TYPES.GET_GEOLOCALISATION: {
      return {
        ...state,
        geolocalisation: action.payload.data,
        loadingGeolocation: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_GEOLOCALISATION): {
      return {
        ...initialState,
        loadingGeolocation: false,
      };
    }
    case REQUEST(ACTION_TYPES.CHECK_EXIST_BON_TRANSPORT):
      return {
        ...state,
      };

    case SUCCESS(ACTION_TYPES.CHECK_EXIST_BON_TRANSPORT): {
      return {
        ...state,
        bonTransportConstraint: action.payload.data,
      };
    }

    case FAILURE(ACTION_TYPES.CHECK_EXIST_BON_TRANSPORT): {
      return {
        ...initialState,
      };
    }
    case ACTION_TYPES.RESET_BON_TRANSPORT: {
      return {
        ...initialState,
      };
    }

    case ACTION_TYPES.CLEAN_GEOLOCALISATION:
      return {
        ...state,
        geolocalisation: null,
      };
    case ACTION_TYPES.SHOW_GENERATE_BP_ERROR:
      return {
        ...state,
        bonTransportError: true,
      };
    case ACTION_TYPES.HIDE_GENERATE_BP_ERROR:
      return {
        ...state,
        bonTransportError: false,
      };
    case ACTION_TYPES.SHOW_GEOLOCALISATION_MODAL:
      return {
        ...state,
        geolocalisationModal: true,
      };
    case ACTION_TYPES.HIDE_GEOLOCALISATION_MODAL:
      return {
        ...state,
        geolocalisationModal: false,
      };
    default:
      return state;
  }
};
